module.exports = __webpack_public_path__ + "media/assets/icons/mountain-672764dd2581e5a15d25d4ffeaa81be2.svg";